import React from 'react'
import { Box, Container, Link, Toolbar } from '@material-ui/core'
import { Link as RouterLink, useLocation } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import { routingConstants } from '../../constants/routing.constants'
import { userService } from '../../services/user.service'

const useStyles = makeStyles(theme => ({
    subMenu: {
        backgroundColor: theme.palette.navigation.main,
    },
    mainMenuLink: {
        color: theme.palette.getContrastText(theme.palette.navigation.main),
        margin: '0 0.6rem',
        fontSize: '1em',
        height: '2rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 'bold',
        borderBottom: '3px solid',
        borderBottomColor: 'transparent',
        '&:hover': {
            borderBottom: '3px solid',
            borderBottomColor: theme.palette.getContrastText(
                theme.palette.navigation.main
            ),
            textDecoration: 'none',
        },
    },
    mainMenuLinkActive: {
        borderBottom: '3px solid',
        borderBottomColor: theme.palette.getContrastText(
            theme.palette.navigation.main
        ),
    },
    subMenuLink: {
        margin: '0 1rem',
        fontSize: '0.8rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 'bold',
        cursor: 'pointer',
        color: theme.palette.getContrastText(theme.palette.navigation.main),
    },
    subMenuLinkActive: {
        borderBottom: '3px solid',
        borderBottomColor: theme.palette.navigation.main,
    },
    subMenuLinkEnabled: {
        color: theme.palette.getContrastText(theme.palette.navigation.main),
    },
    subMenuLinkDisabled: {
        color: theme.variables.lightGrey,
        cursor: 'default',
        '&:hover': {
            textDecoration: 'none',
        },
    },
    subMenuHeader: {
        fontSize: '1rem',
        margin: '0 1rem 0 0',
    },
}))

const navItems = [
    { title: 'Service', to: routingConstants.paths.serviceConfiguration },
    { title: 'Users', to: routingConstants.paths.userConfiguration },
    { title: 'Content', to: routingConstants.paths.contentConfiguration },
    {
        title: 'Authentication',
        to: routingConstants.paths.authenticationConfiguration,
    },
]

export function SubHeader() {
    const classes = useStyles()
    const location = useLocation()

    const linkIsActive = path => {
        return location.pathname.startsWith(path)
    }

    return (
        <div>
            <Box className={classes.subMenu} boxShadow={1}>
                <Container maxWidth='xl'>
                    <Toolbar variant='dense'>
                        <Box display='flex' alignItems='center' flexGrow={1}>
                            {!!userService.getManagedService() &&
                                navItems.map(menuItem => (
                                    <Link
                                        key={menuItem.title}
                                        component={RouterLink}
                                        to={menuItem.to}
                                        className={
                                            linkIsActive(menuItem.to)
                                                ? [
                                                      classes.mainMenuLink,
                                                      classes.mainMenuLinkActive,
                                                  ].join(' ')
                                                : classes.mainMenuLink
                                        }>
                                        <span>{menuItem.title}</span>
                                    </Link>
                                ))}
                        </Box>
                    </Toolbar>
                </Container>
            </Box>
        </div>
    )
}
